import { createSlice } from '@reduxjs/toolkit';


const INITIAL_STATE = {
    conGptFilesPopover: false,
    doazGptFilesPopover: false,
};

export const userDashboardSlice = createSlice({
    name: 'dashboard',
    initialState: INITIAL_STATE,
    reducers: {
        updateConGptPopover: (state, { payload }) => {
            state.conGptFilesPopover = payload
        },
        updateDoazGptPopover: (state, { payload }) => {
            state.doazGptFilesPopover = payload
        }
    },
    extraReducers: (builder) => {},
});

export const {
    updateConGptPopover,
    updateDoazGptPopover
} = userDashboardSlice.actions;

export const userDashboardReducer = userDashboardSlice.reducer;
